import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import AAdsBanner from '../Ads/AAdsBanner';
import './Layout.css';
import PaymentPopup from '../PaymentPopup/PaymentPopup';
import AuthModal from '../Auth/AuthModal';
import { useFreePlay } from '../../context/FreePlayContext';
import { MusicProvider } from '../../context/MusicContext';

const Layout = () => {
  const { isPaymentOpen, closePayment, paymentReason, state } = useFreePlay();

  // Dark mode: toggled from the mansion menu, persisted per-browser, applied
  // as a body class so every screen's CSS can restyle for it.
  const [darkMode, setDarkMode] = useState(
    () => localStorage.getItem('bitwheel.darkMode') === '1'
  );

  useEffect(() => {
    document.body.classList.toggle('dark-mode', darkMode);
    // The <html> element is styled white by :root in App.css and CSS can't
    // reach a parent from body.dark-mode — mobile browsers paint page edges
    // and overscroll from the root, which showed as a white border around
    // the dark gameboard. Repaint the root directly.
    document.documentElement.style.backgroundColor = darkMode ? '#0f172a' : '';
    document.documentElement.style.colorScheme = darkMode ? 'dark' : '';
    localStorage.setItem('bitwheel.darkMode', darkMode ? '1' : '0');
    return () => {
      document.body.classList.remove('dark-mode');
      document.documentElement.style.backgroundColor = '';
      document.documentElement.style.colorScheme = '';
    };
  }, [darkMode]);

  const toggleDarkMode = useCallback(() => setDarkMode((prev) => !prev), []);

  const initialPlan = useMemo(() => {
    if (paymentReason === 'limit') {
      return state.emailSignupGranted ? 5 : 0;
    }
    return undefined;
  }, [paymentReason, state.emailSignupGranted]);

  const handleClosePopup = useCallback(() => {
    closePayment();
  }, [closePayment]);

  return (
    <MusicProvider>
      <div className="app-shell">
        <Header darkMode={darkMode} onToggleDarkMode={toggleDarkMode} />
        <AAdsBanner />
        <div className="app-shell__body">
          <Sidebar />
          <main className="app-shell__content">
            <Outlet />
          </main>
        </div>
        {isPaymentOpen && (
          <PaymentPopup onClose={handleClosePopup} initialPlan={initialPlan} />
        )}
        <AuthModal />
      </div>
    </MusicProvider>
  );
};

export default Layout;

